import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { locationChange } from 'store/location'
import { buildV3Location } from './locationUtils'
import { syncViewportForPathname } from './viewportWidth'

/**
 * Keeps Redux location state in sync with React Router v6 and restores scroll-on-nav.
 */
export default function LocationSync({ onUpdate }) {
  const location = useLocation()
  const dispatch = useDispatch()
  const { pathname, search, hash } = location

  useEffect(() => {
    dispatch(locationChange(buildV3Location(location)))
    syncViewportForPathname(pathname, dispatch)
    if (typeof onUpdate === 'function') {
      onUpdate()
    } else {
      window.scrollTo(0, 0)
    }
    // Intentionally depend on path parts, not the location object identity.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, pathname, search, hash, onUpdate])

  return null
}
